import React from "react";
import image from "../../assets/oph_1_jm_r_1.png";
import EasyToCustomizeIcon from "../../assets/svgs/Easy_To_Customize.svg";
import FreeUpdateIcon from "../../assets/svgs/Free_Update.svg";
import FullySecuredIcon from "../../assets/svgs/Fully_Secured.svg";
import UserFriendlyIcon from "../../assets/svgs/User_Friendly.svg";
import "./FeaturCard.scss";
import FeaturCard from "./FeaturCard";

const featuresList = [
  {
    title: `تحديث مجاني`,
    description: `MyCar هو تطبيق يهدف إلى تسهيل وتحسين تجربة شراء وتمويل السيارات عبر الإنترنت`,
    image: FreeUpdateIcon,
    color: "#0c74c2",
    align: "end",
  },
  {
    title: `سهل الاستخدام`,
    description: `MyCar هو تطبيق يهدف إلى تسهيل وتحسين تجربة شراء وتمويل السيارات عبر الإنترنت`,
    image: UserFriendlyIcon,
    color: "#f18301",
    align: "end",
  },
  {
    title: `سهل التخصيص`,
    description: `MyCar هو تطبيق يهدف إلى تسهيل وتحسين تجربة شراء وتمويل السيارات عبر الإنترنت`,
    image: EasyToCustomizeIcon,
    color: "#f4cc26",
    align: "start",
  },
  {
    title: `مؤمن بالكامل`,
    description: `MyCar هو تطبيق يهدف إلى تسهيل وتحسين تجربة شراء وتمويل السيارات عبر الإنترنت`,
    image: FullySecuredIcon,
    color: "#303030",
    align: "start",
  },
  // {
  //   title: `Free Update`,
  //   description: `MyCar is an application that aims to facilitate and improve the online car buying and financing experience`,
  //   image: FreeUpdateIcon,
  //   color: "#0c74c2",
  //   align: "end",
  // },
  // {
  //   title: `User Friendly`,
  //   description: `MyCar is an application that aims to facilitate and improve the online car buying and financing experience`,
  //   image: UserFriendlyIcon,
  //   color: "#f18301",
  //   align: "end",
  // },
  // {
  //   title: `Easy To Customize`,
  //   description: `MyCar is an application that aims to facilitate and improve the online car buying and financing experience`,
  //   image: EasyToCustomizeIcon,
  //   color: "#f4cc26",
  //   align: "start",
  // },
  // {
  //   title: `Fully Secured`,
  //   description: `MyCar is an application that aims to facilitate and improve the online car buying and financing experience`,
  //   image: FullySecuredIcon,
  //   color: "#303030",
  //   align: "start",
  // },
];
function Features() {
  return (
    <div className="features-list-wrapper" id="feature-section">
      <div className="container">
        <div className="section-header">
          <h1 className="page-title">جرب ميزات رائعة</h1>
        </div>
        <div className="features-grid-holder">
          <div className="space-y-6">
            {featuresList
              .filter((f) => f.align === "end")
              .map((f, i) => (
                <FeaturCard key={i + f.title} {...f} />
              ))}
          </div>
          <img
            src={image}
            alt={"Services"}
            className="m-auto md:col-span-2 lg:col-span-1 lg:order-2"
            data-aos-delay={800}
            data-aos="zoom-out"
          />

          <div className="space-y-6 lg:order-3">
            {featuresList
              .filter((f) => f.align === "start")
              .map((f, i) => (
                <FeaturCard key={i + f.title} {...f} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
